import type { Action } from '../actions';
import type { BdrValuationCalendarsBlackoutDatesState } from './valuationDateCalendars.model';
import { initialBdrValuationCalendarsBlackoutDatesState } from './valuationDateCalendars.model';

export function valuationDateCalendarsReducer(
  state: BdrValuationCalendarsBlackoutDatesState = initialBdrValuationCalendarsBlackoutDatesState,
  action: Action,
): BdrValuationCalendarsBlackoutDatesState {
  switch (action.type) {
    case 'VALUATION_CALENDARS_BLACKOUT_DATES_RECEIVED':
      return { ...state, ...action.calendars };
    default:
      return state;
  }
}
